import { render, staticRenderFns } from "./KanbanListUnassigned.vue?vue&type=template&id=476097e6&"
import script from "./KanbanListUnassigned.vue?vue&type=script&lang=js&"
export * from "./KanbanListUnassigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports